<template>
  <div class="footer-page">
    <!-- 协议 -->
    <div v-if="protocolList.includes($route.query.type)">
      <div v-html="protocolContent"
           style="padding:33px"></div>
    </div>
    <!-- 帮助与反馈 -->
    <div v-if="$route.query.type === 'help' "
         :key="currKey"
         class="help">
      <div class="help-header por">
        <span class="help-header-btn flex aic jcc poa"
              @click="btnEvent">常见问题</span>
      </div>
      <div class="help-form">
        <i-form :model="formData"
                :rules="rules"
                ref="dfForm"
                label-position="top">
          <form-item label="选择类型"
                     prop="type">
            <radio-group v-model="formData.type"
                         class="help-form-type">
              <Radio :label="v.id"
                     v-for="v in typeList"
                     :key="v.id">{{v.name}}</Radio>
            </radio-group>
          </form-item>
          <form-item label="请写下您的意见或建议吧，我们会尽快处理您的反馈"
                     prop="remark">
            <i-input v-model="formData.remark"
                     type="textarea"
                     rows="4"
                     cols="114"
                     placeholder=""
                     class="help-form-textarea"></i-input>
          </form-item>
          <form-item class="por">
            <df-upload :multiple="true"
                       :length="6"
                       action="tool/upload/up"
                       :v-model="formData.images"
                       imgKey=""
                       img-hight="88"
                       :del-icon="true"
                       width="80%"
                       ref="dfUpload"
                       :showLoading="true"
                       @success="uploadSuccess(arguments)">
              <div class="help-form-upload-btn">
                <i-button type="primary">上传图片</i-button><span
                      class="help-form-upload-span">（图片大小请控制在2M以内，最多6张）</span>
              </div>
            </df-upload>
            <div class="w100 zi1 poa t0 l0 h100 bar"></div>
          </form-item>
          <form-item label="您的微信号/手机号，方便我们联系了解情况"
                     prop="contact">
            <i-input v-model="formData.contact"
                     placeholder=""
                     class="help-form-textarea"
                     @on-keyup="changeInput"></i-input>
          </form-item>
          <form-item class="help-form-btn flex aic jcc">
            <i-button type="primary"
                      :loading="loading"
                      :disabled="btnStatus"
                      @click="submit">提交</i-button>
          </form-item>
        </i-form>
      </div>
    </div>
    <div v-if="!protocolList.includes($route.query.type) && $route.query.type !== 'help'"
         style="padding:33px">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "FooterDetails",
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    $route () {
      this.changePage(this.$route.query.type);
      this.formData = {
        type: '',
        remark: '',
        contact: '',
        images: [],
        version: 'V3.3.0',
        name: '格灵课堂',
      }
    },
    formData: {
      handler () {
        this.handleBtnStatus();
      },
      deep: true,
    }
  },
  data () {
    return {
      protocolList: ['privacy', 'user_protocol', 'vip_protocol'],
      protocolContent: '',
      currKey: 0,
      formData: {
        type: '',
        remark: '',
        contact: '',
        images: [],
        version: 'V3.3.0',
        name: '格灵课堂',
      },
      btnStatus: true,
      typeList: [
        { id: '1', name: '会员问题' },
        { id: '2', name: '账号问题' },
        { id: '3', name: '内容问题' },
        { id: '4', name: '客户端' },
        { id: '5', name: '其他问题' },
      ],
      rules: {
        type: { required: true, message: '请选择问题类型', trigger: 'change', },
        remark: { required: true, message: '请填写您的意见或建议', trigger: 'blur' },
        contact: [
          { required: true, message: '请填写联系方式', trigger: 'blur', },
          { pattern: /^[a-zA-Z\d_-]{5,20}$/, message: '可输入类型为 ： 6-20位数字、字母、下划线、减号或它们的组合', trigger: 'blur' }
        ]
      },
      content: '',
      timer: null,
      loading: false
    }
  },
  methods: {
    changePage (type) {
      switch (type) {
        case 'company':
          this.getInfo(1);
          break;
        case 'join':
          this.getInfo(2);
          break;
        case 'business':
          this.getInfo(3);
          break;
        case 'privacy':
        case 'user_protocol':
        case 'vip_protocol':
          this.http.NEWGetProtocol({ product_id: 13, name: type }).then(res => {
            this.protocolContent = res.value;
          }).catch(this.$err);
          break;
        case 'tort':
          this.getInfo(4);
          break;
      }
    },
    btnEvent () {
      this.OpenRouter({
        path: '/help/core',
      });
      // this.$router.push({
      //   path: '/help/core',
      // });
    },
    submit () {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (!this.userInfo.uid) {
          this.ToLogin();
          return;
        }
        this.$refs.dfForm.validate(async (valid) => {
          if (valid) {
            this.loading = true
            await this.$refs.dfUpload.submit();
            let form = {
              ...this.formData,
              ...this.Product,
              uid: this.userInfo.uid,
              type: +this.formData.type,
            }
            this.http.sumbitFeedback({ ...form }).then(() => {
              this.$Message.success('提交成功');
              this.formData = {
                type: '',
                remark: '',
                contact: '',
                images: [],
                version: 'V3.3.0',
                name: '格灵课堂',
              }
              this.currKey++;

            }).catch(this.$err).finally(()=>{
              this.loading = false;
            });
          } else {
            this.$Message.error('请完善反馈');
            return
          }
        })
      }, 500)
    },
    uploadSuccess (arg) {
      let arr = arg[1];
      this.formData.images = arr.map(v => {
        return { fileurl: v.savename, size: v.size }
      });
    },
    getInfo (id) {
      this.http.NEWGetCfgInfo({ id, }).then(res => {
        this.content = res.content;
      }).catch(this.$err);
    },
    handleBtnStatus () {
      if (Object.keys(this.formData).filter(v => !this.formData[v]).length) {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
    changeInput () {
      let phone = this.formData.contact;
      this.formData.contact = phone.replace(/[\u4E00-\u9FA5]/g, '');
    }
  },
  created () {
    this.changePage(this.$route.query.type);
    if (this.$route.query.type === 'help' && !this.userInfo.uid) {
      this.ToLogin();
    }
  }
}
</script>

<style scoped lang="less">
@import '../../assets/less/function';

/deep/ .mine-ico {
  &.img {
    .spirit(url(../../assets/images/user_icons.png));
  }
  &:not(.img) {
    .spirit-mask(url(../../assets/images/user_icons.png));
  }
  &:after {
    margin-right: 16px;
    width: 22px;
    height: 22px;
    background-color: #959595;
  }
  &.is-vip {
    &:after {
      width: 24px;
      height: 23px;
      mask-position: -50px -2px;
      background-color: #ffc264;
    }
  }
  &.checkbox-df {
    &:after {
      margin: 0;
      width: 19px;
      height: 19px;
      mask-position: -77px -3px;
      background-color: #fff;
    }
  }
  &.checkbox-check {
    &:after {
      margin: 0;
      width: 19px;
      height: 19px;
      mask-position: -99px -3px;
      background-color: #fff;
    }
  }
  &.hover-play {
    &:after {
      margin-right: 0;
      width: 44.3px;
      height: 44.3px;
      mask-position: -52px -30px;
      background-color: #fff;
    }
  }
  &.hover-delete {
    &:after {
      margin-right: 0;
      width: 24px;
      height: 24px;
      background-position: -121px -1px;
    }
  }
  &.lost-time {
    &:after {
      margin-right: 0;
      width: 58px;
      height: 58px;
      background-position: -102px -28px;
    }
  }
  &.tv {
    &:after {
      margin-right: 0;
      width: 104px;
      height: 85px;
      background-position: -229px -2px;
    }
  }
  &.no-follow {
    &:after {
      margin-right: 0;
      width: 104px;
      height: 85px;
      background-position: -340px -2px;
    }
  }
  &.audio {
    &:after {
      margin-right: 0;
      width: 25px;
      height: 25px;
      background-position: -146px -1px;
    }
  }
  &.play {
    &:after {
      mask-position: -3px -2px;
    }
  }
  &.hart {
    &:after {
      margin-right: 0;
      width: 14px;
      height: 14px;
      mask-position: -193.9px -3px;
      background-color: #999;
    }
  }
  &.collection {
    &:after {
      mask-position: -3px -26px;
    }
  }
  &.follow {
    &:after {
      mask-position: -3px -50px;
    }
  }
  &.course {
    &:after {
      mask-position: -3px -74px;
    }
  }
  &.vip {
    &:after {
      mask-position: -3px -98px;
    }
  }
  &.setting {
    &:after {
      mask-position: -3px -122px;
    }
  }
  &.edit-more {
    &:after {
      margin-right: 8px;
      width: 18px;
      height: 18px;
      mask-position: -173px -3px;
    }
  }
}

.help {
  .help-header {
    height: 120px;
    // background-color: #1177ff;
    background-image: url('../../assets/images/footer/pic_yjfk.png');
    background-size: 100% 100%;
  }
  .help-header-btn {
    left: 76px;
    bottom: 26px;
    width: 92px;
    height: 28px;
    border-radius: 14px;
    color: #ffffff;
    background-color: #fd950e;
    &:hover {
      cursor: pointer;
    }
  }
  .help-form {
    padding: 0 33px;
    padding-top: 33px;
    .help-form-type {
      /deep/ .ivu-radio-group-item {
        margin-right: 40px;
      }
    }
    .help-form-textarea {
      /deep/ .ivu-input {
        background: rgba(235, 237, 240, 0.5);
        border: none;
      }
    }
    .help-form-btn {
      /deep/ .ivu-btn {
        width: 160px;
        height: 40px;
        border-radius: 20px;
        font-size: 16px;
      }
    }

    .help-form-upload-btn {
      /deep/ .ivu-btn {
        width: 80px;
        height: 28px;
        border-radius: 14px;
        font-size: 12px;
      }
    }
    .help-form-upload-span {
      display: inline-block;
      margin-left: 15px;
      font-size: 12px;
      color: #999fa6;
    }
  }
}

/deep/ .img-item {
  margin-top: 12px !important;
}

.bar {
  opacity: 0;
  // background-color: pink;
  height: 40px;
  margin-left: 10%;
}
</style>